<template>
	<div class="extend-features-wrap">
		<div class="user-comment-wrap">
			<div class="ds_fx">
				<div class="user-comment-container">
					<div class="user-comment-desc">
						<span>
							<div class="desc-top">
								<h2 class="animate">{{ $t('osTitle') }}</h2>
								<h4 class="animate">{{ $t('osSecTitle') }}</h4>
							</div>
							<div class="desc-text">
								<p class="animate">{{ $t('osIntro') }}</p>
							</div>
						</span>
					</div>
					<div class="view-comment-btn" v-show="!isShowBtn">
						<div class="prev-btn btn" @click="onPrev" :class="currentIndex == 0 ? 'clickable' : ''">
							<span class="iconfont icon-zuojiantou"></span>
						</div>
						<div class="next-btn btn" @click="onNext"
							:class="currentIndex == extendedList.length -1 ? 'clickable' : ''">
							<span class="iconfont icon-youjiantou"></span>
						</div>
					</div>
				</div>
				<div class="comment-list-wrap">
					<div ref="wrapHeight" class="comment-item ml-32" v-for="(commont, index) in extendedList"
						:key="commont.id" :style="{
						transform: `translateX(${(index - currentIndex) * 100}%)`,
					    transition: 'opacity 300ms, transform 300ms, visibility 300ms',
						opacity: (index - currentIndex) * 100 < 0 ? 0 : 1,
					    visibility: 'visible'
					  }">
						<div class="features-image">
							<img v-lazy="`/res/img/${commont.path}`" />
						</div>
						<div class="features-intro-inner">
							<div class="title">{{ $t(`extended.${commont.id}`) }}</div>
							<div class="features-intro-text">
								{{ $t(`extended.intro${index + 1}`) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TvFeatures',
		components: {},
		data() {
			return {
				extendedList: [{
						id: 'remote',
						path: 'features-img-1.png',
						title: '遥控器快捷键自定义设置',
						intro: '用户自定义遥控器的按键功能，适配多种遥控器设备，并配合AURORA最新系统，实现快捷操作、一键启动应用等功能'
					},
					{
						id: 'timezone',
						path: 'features-img-3.png',
						title: '一键修复网络',
						intro: '网络限制或NTP服务器故障导致无法正常上网时，可一键切换NTP服务器，快速恢复网络时间同步'
					},
					{
						id: 'clean',
						path: 'features-img-2.png',
						title: '一键式内存清理',
						intro: '只需轻点，即可轻松清理电视缓存，'
					}
				],
				CommentWrapHeight: '',
				currentIndex: 0,
				isShowBtn: true,
			};
		},
		computed: {},
		methods: {
			getDeviceType() {
				const ua = navigator.userAgent;
				const isMobile = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
				return isMobile
			},
			onPrev() {
				if (this.currentIndex > 0) {
					this.currentIndex--
				} else {
					// 如果到达开头，只能下一张
					this.currentIndex = 0
				}
			},
			onNext() {
				if (this.currentIndex < this.extendedList.length - 1) {
					this.currentIndex++
				} else {
					// 如果到达末尾，循环回到上一张
					this.currentIndex = this.extendedList.length - 1
				}
			}
		},
		created() {

		},
		mounted() {
			this.isShowBtn = this.getDeviceType()
		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.extend-features-wrap {
		padding: 80px 0;
		overflow: hidden;
		color: #fff;
		position: relative;

		.user-comment-wrap {
			max-width: 1280px;
			padding: 0 24px 0;
			overflow: visible;
			margin-left: auto;
			margin-right: auto;

			.user-comment-container {
				width: 40%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.user-comment-desc {
					.desc-top {
						word-break: break-all;

						h2 {
							font-size: 40px;
							font-family: 'Alibaba PuHuiTi M';
						}

						h4 {
							font-size: 40px;
							color: #1ef8a0;
							font-family: 'Alibaba PuHuiTi H';
							font-weight: normal !important;
						}
					}

					.desc-text {
						padding-top: 20px;
						font-size: 20px;
						font-family: 'Alibaba PuHuiTi R', sans-serif;
						// font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
					}
				}

				.view-comment-btn {
					position: relative;
					z-index: 99;
					display: flex;

					.btn {
						width: 48px;
						height: 48px;
						line-height: 48px;
						background: rgba(255, 255, 255, 0.1);
						text-align: center;
						border-radius: 32px;
						border: 1px solid rgba(171, 176, 194, 0.1);
						cursor: pointer;
						color: #fff;

						.iconfont {
							font-size: 20px;
							font-weight: bold;
						}
					}

					.next-btn {
						margin-left: 20px;
					}

					.clickable {
						color: #6b7174;
						background: none;
						border: 1px solid rgba(171, 176, 194, 0.1);
					}

					.clickable:hover {
						color: #6b7174 !important;
						background: none !important;
					}

					.btn:hover {
						color: #111836;
						background-color: #1EF8A0;
					}
				}
			}

			.comment-list-wrap {
				width: 60%;
				padding-left: 116px;
				position: relative;
				overflow: visible;
				min-height: 384px;
				height: 640px;

				.comment-item {
					display: flex;
					justify-content: space-between;
					position: absolute;
					max-width: 546px;
					width: 100%;
					height: 100%;
					box-sizing: border-box;

					.features-image {
						width: 100%;
						height: 100%;

						img {
							display: block;
							width: 100%;
							height: 100%;
						}
					}

					.features-intro-inner {
						padding: 25px 40px;
						position: absolute;
						bottom: 0;
						width: calc(100% - 32px);
						box-sizing: border-box;
						background: rgba(0, 0, 0, 0.5);

						.title {
							word-break: break-all;
							font-size: 32px;
						}

						.features-intro-text {
							color: #AFB5CE;
							font-size: 15px;
							line-height: 30px;
						}
					}
				}

				.ml-32 {
					padding-right: 32px;
				}

				.comment-text {
					line-height: 32px;
					font-size: 24px;
					font-family: 'Alibaba PuHuiTi M';
					word-break: break-all;
					// display: -webkit-box;          
					// -webkit-line-clamp: 9;          
					// -webkit-box-orient: vertical;  
					// overflow: hidden;             
					// text-overflow: ellipsis;   
				}

				.comment-user {
					padding-top: 20px;
					display: flex;

					.commont-user-avatr {
						width: 32px;
						height: 32px;
						line-height: 32px;
						border-radius: 50%;
						color: #3A7AFF;
						text-align: center;
						background: #CCDCFF;
						margin-right: 8px;
					}

					.goods {
						flex: 1;

						.commont-user-date {
							font-size: 14px;
							line-height: 14px;
							color: #869ABE;
						}
					}

				}
			}
		}
	}


	@media (max-width: 768px) {
		.extend-features-wrap {
			padding-bottom: 32px !important;
		}

		.user-comment-inner {
			position: relative;
		}

		::-webkit-scrollbar {
			display: none;
		}

		::-webkit-scrollbar-track {
			background: #fff;
			border-radius: 4px;
		}

		::-webkit-scrollbar-thumb {
			background: #222a4a;
			border-radius: 4px;
		}

		::-webkit-scrollbar-thumb:hover {
			background: #282f4a;
		}

		.comment-list-wrap {
			overflow-x: scroll !important;
			width: 100% !important;
			height: 348px !important;
		}

		.ds_fx {
			flex-direction: column;
			padding-bottom: 32px;

			.user-comment-container {
				width: 100% !important;
			}

			.desc-text {
				padding-bottom: 20px;
			}

			.view-comment-btn {
				position: absolute !important;
				bottom: 0;
				right: 24px;
			}

			.comment-list-wrap {
				padding: 0 !important;
			}
		}

	}
</style>